<template>
	<Teleport to="html">
		<SelectOrganizationModal :show="orgStore.getShowChooseModal" @show-contact-us="showContactUs = true" />
	</Teleport>

	<Teleport to="html">
		<ContactUsModal v-if="showContactUs" :show="showContactUs" @dismiss="showContactUs = false" />
	</Teleport>

	<AuthedLayout>
		<div class="flex flex-col space-y-8">
			<DashboardMessagePanel />
			<DashboardActionsPanel />
		</div>
	</AuthedLayout>
</template>

<script setup lang="js">
import AuthedLayout from '@/layouts/AuthedLayout.vue'
import { ref } from 'vue'
import SelectOrganizationModal from '@/views/Organizations/SelectOrganizationModal.vue'
import DashboardActionsPanel from '@/components/Dashboard/DashboardActionsPanel.vue'
import DashboardMessagePanel from '@/components/Dashboard/DashboardMessagePanel.vue'
import ContactUsModal from '@/views/Contact/ContactUsModal.vue'
import { useOrganizationStore } from '@/stores/organizationStore.js'

const orgStore = useOrganizationStore()
const showContactUs = ref(false)

</script>
